export const getCookie = (key: string) => {
  const allCookies = document.cookie.split(';');
  let cookieValue;

  allCookies.forEach((cookie) => {
    const [name, value] = cookie.trim().split('=');
    if (name === key) return (cookieValue = value);
  });

  if (!cookieValue) return null;

  return cookieValue;
};

export const setCookie = (
  cookieName: string,
  cookieValue: any,
  expiration?: Date
) => {
  document.cookie = `${cookieName}=${cookieValue}; path=/; SameSite=None; Secure; expires=${
    expiration?.toUTCString() ?? 0
  }`;
};
